/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClmUserInfo
 */
export interface ClmUserInfo {
    /**
     * 
     * @type {string}
     * @memberof ClmUserInfo
     */
    uNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClmUserInfo
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof ClmUserInfo
     */
    emailAddress?: string;
}

/**
 * Check if a given object implements the ClmUserInfo interface.
 */
export function instanceOfClmUserInfo(value: object): value is ClmUserInfo {
    return true;
}

export function ClmUserInfoFromJSON(json: any): ClmUserInfo {
    return ClmUserInfoFromJSONTyped(json, false);
}

export function ClmUserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClmUserInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'uNumber': json['uNumber'] == null ? undefined : json['uNumber'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'emailAddress': json['emailAddress'] == null ? undefined : json['emailAddress'],
    };
}

export function ClmUserInfoToJSON(json: any): ClmUserInfo {
    return ClmUserInfoToJSONTyped(json, false);
}

export function ClmUserInfoToJSONTyped(value?: ClmUserInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uNumber': value['uNumber'],
        'fullName': value['fullName'],
        'emailAddress': value['emailAddress'],
    };
}

